
import React from "react";
import './scss/App.scss'
import Weather from "./components/Weather";
function App() {
  return (
    <div className="App">
    <Weather />
    </div>
  );
}

export default App;